import { useEffect, useState } from 'react';
import {Keyboard, KeyboardEvent} from 'react-native';

export const useKeyboard = () => {
    const [keyboardHeight, setKeyboardHeight] = useState(0);

    useEffect(() => {
        function onKeyboardWillShow(e: KeyboardEvent) { // Remove type here if not using TypeScript
            setKeyboardHeight(e.endCoordinates.height);
        }

        function onKeyboardWillHide(e: KeyboardEvent) {
            setKeyboardHeight(0);
        }

        const showSubscription = Keyboard.addListener('keyboardWillShow', onKeyboardWillShow);
        const hideSubscription = Keyboard.addListener('keyboardWillHide', onKeyboardWillHide);
        return () => {
            showSubscription.remove();
            hideSubscription.remove();
        };
    }, []);

    return keyboardHeight;
};
